<template>
  <div>
    <div class="footContent">
        <ul class="footNav">
          <li class="footNac_li">
            大数据及效能
            <ul>
              <li><a href="#/hadoop/beanstalk" target="_blank">Beanstalk平台</a></li>
              <li><a href="#/hadoop/bigdataPlatform" target="_blank">大数据平台</a></li>
              <li><a href="#/hadoop/agileManagement" target="_blank">敏捷管理咨询</a></li>
              <li><a href="#/hadoop/qualityManagement" target="_blank">质量管理咨询</a></li>
            </ul>
          </li>
          <li class="footNac_li">
            城市大脑
            <ul>
              <li><a href="#/cityBrain/socialSolutions" target="_blank">社会态势解决方案</a></li>
              <li><a href="#/cityBrain/importantSolutions" target="_blank">重点防护解决方案</a></li>
              <li><a href="#/cityBrain/warningSolutions" target="_blank">警情中心解决方案</a></li>
              <li><a href="#/cityBrain/manySolutions" target="_blank">一标N实解决方案</a></li>
            </ul>
          </li>
          <li class="footNac_li">
            可视化
            <ul>
              <li><a href="#/visual/product" target="_blank">产品</a></li>
              <li><a href="#/visual/developmentPlatform" target="_blank">开发平台</a></li>
              <li><a href="#/visual/apply" target="_blank">可视化应用</a></li>
              <li><a href="#/visual/digitalTwin" target="_blank">数字孪生应用</a></li>
              <li><a href="#/visual/caseIntroduction" target="_blank">案例介绍</a></li>
            </ul>
          </li>
          <li class="footNac_li">
            人力服务
            <ul>
              <li><a href="#/humanServices" target="_blank">人力服务解决方案</a></li>
            </ul>
          </li>
          <li class="footNac_li">
            新闻中心
            <ul>
              <li><a href="#/newsCenter" target="_blank">公司新闻</a></li>
            </ul>
          </li>
          <li class="footNac_li">
            关于我们
            <ul>
              <li><a href="#/aboutus" target="_blank">公司简介</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="footBtm">
        <div class="footBtm_left">
          <p><img src="../../public/img/rBQB.png" alt=""> <a  href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">沪公网安备31011302005994号</a>&nbsp;&nbsp;&nbsp;&nbsp;<a  href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">沪ICP备20009197号-1</a></p>
          <p>Copyright©️2017-2021上海功存智能科技有限公司</p>
        </div>
        <div class="footBtm_right">
          <el-tooltip content="上海市宝山区国权北路615弄10号" placement="top">
            <span class="img_1"></span>
          </el-tooltip>
          <el-tooltip content="021-55890650" placement="top">
            <span class="img_2"></span>
          </el-tooltip>
          <el-tooltip content="marketing@comzen.net" placement="top">
            <span class="img_3"></span>
          </el-tooltip>
          <el-tooltip placement="top" popper-class="tips">
            <img slot="content" src="../../public/img/erweima.png" alt=""/>
            <span class="img_4"></span>
          </el-tooltip>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'footerMenu'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss'>
@import '~@/assets/style/elementUi.scss';
@import '~@/assets/style/public.scss';
.footNac_li{
  ul{
    a{}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue